import React from 'react';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Chip from '@mui/material/Chip';
import { useWebhookEventsProducts } from '../utils';

const renderStatus = (status: string) => {
  if (status === 'Active') {
    return <Chip label="Aktivt" color="success" variant="filled" />;
  }

  if (status === 'Cancelled') {
    return <Chip label="Avslutat" color="error" variant="filled" />;
  }
};

const WebhookEventsProducts = ({ productWebhookEvents }: { productWebhookEvents: any }) => {
  const { webhookEvents } = useWebhookEventsProducts(productWebhookEvents);

  return (
    <Box>
      <Typography sx={{ fontSize: '16px' }} color="text.secondary" gutterBottom>
        Events från WebHook
      </Typography>
      <TableContainer component={Paper}>
        <Table sx={{}} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="left">Produkt</TableCell>
              <TableCell align="left">Status</TableCell>
              <TableCell align="left">Uppdaterad</TableCell>
              <TableCell align="left">Mottagit</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {webhookEvents?.map((row: any) => (
              <TableRow
                key={row.key}
                sx={{
                  '&:last-child td, &:last-child th': {
                    border: 0,
                  },
                }}
              >
                <TableCell align="left">{row?.productId}</TableCell>
                <TableCell align="left">{renderStatus(row?.status)}</TableCell>
                <TableCell align="left">{row?.updatedAt}</TableCell>
                <TableCell align="left">{row?.received}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default WebhookEventsProducts;
